import { nullish, object, picklist, string } from 'valibot'

export const whitelistedFields = picklist([
  // common fields
  'id',
  'idLowerCase',
  'title',
  'nodeType',
  'bodytext',
  'contentEdgeNgram',
  'legal_areas',
  '_text_',
  'keywords_lc',
  'priority',

  // Literature specific fields
  'secondLevelNodeType',
  'pageNumberString',
  'pageCounter',
  'children',
  'pages',
  'chapters',
  'author_list',
  'dateOfPublication',
  'previousEdition',
  'editionNumber',
  'lastEdition',
  'subtitle',
  'description',
  'publisher',
  'isbn',
  'placeOfPublication',
  'language',
  '_version_',

  // Law and law commentary specific fields
  'shortTitle',
  'lastChangeInForce',
  'dateInForce',
  'lastUpdatedByEditor',
  'originalPublicationDate',
  'isRepealed',
  'isSuccessor',
  'repealedLawId',
  'repealedByLawId',
  'replacesLawId',
  'miscInformation',
  'rootId',
  'lawId',
  'lawFragmentId',
  'ezMainNodeId',
  'infoNoticeObjectId',
  'path_location',
  'paragraphTitle',
  'timestamp',
  'chapterTitle',
  'curatedReferences',
  'authorName',
  'authorId',
  'editionId',
  'supplementType',

  // Author specific fields
  'shortBio',
  'education',
  'remoteId',
  'image',
  'ezLocationId',
  'ezObjectId',

  // Journals specific fields
  'year',
  'volume',
  'issue',
  'firstPage',
  'lastPage',
  'journals',
  'leder',
  'doi',
  'issueDoi',
  'toc',
  'articles',
  'coverImage',
  'pageNumber',
  'publisherId',
  'tocEntry',
  'coverImageLarge',
  'kolofon',
  'author',
  'abstract',
  'publish_date',
  'journalId',
  'journalProfile',

  // Footnote specific fields
  'footnoteId',

  // News notice specific fields
  'noticeType',

  // Template specific fields
  'files',
  'url'
])

// Base schema for common fields across all items
export const commonSchema = object({
  id: string(),
  idLowerCase: nullish(string()),
  title: nullish(string()),
  timestamp: nullish(string()),
})
